interface OrderLineItem {
    price?: number
    quantity?: number
    hasPricingGift?: boolean
}

export const calculatePurchaseTotalValue = (items: OrderLineItem[]): number => {
    return items.reduce((acc, item) => {
        const price = item.price ?? 0
        const quantity = item.quantity ?? 1
        const hasPricingGift = item.hasPricingGift ?? false

        const lineValue = hasPricingGift ? 0 : price * quantity
        return acc + lineValue
    }, 0)
}
